export default "__VITE_ASSET__e76df825__"